import React from "react";
import { Link } from "react-router-dom";
import logo from "./../assets/images/logo-ngs.jpeg";

const NavMenu = () => {
  const WHATSAPP_LINK =
    "https://wa.me/5511999999999?text=Ol%C3%A1%2C+preciso+de+orienta%C3%A7%C3%A3o+jur%C3%ADdica+urgente.";

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200">
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex h-20 items-center justify-between">
          
          {/* Logo */}
          <a href="/" className="flex items-center gap-3">
            <img
              src={logo}
              alt="Logo NGS Advogada"
              className="h-14 w-auto"
            />
          </a>

          {/* Menu */}
        
            <nav className="hidden lg:flex gap-10 text-lg xl:text-xl font-medium text-gray-700">

            <Link to="/" className="hover:text-slate-900">
              Início
            </Link>
            <Link to="/#sobre" className="hover:text-slate-900">
              Quem Sou Eu
            </Link>
            <Link to="/#equipe/" className="hover:text-slate-900">
              Equipe
            </Link>
            <Link to="/#artigos/" className="hover:text-slate-900">
              Artigos
            </Link>
            <Link to="/#contato" className="hover:text-slate-900">
              Contato
            </Link>
          </nav>

          {/* Ações */}
          <div className="flex items-center gap-6">
            <a
              href="#areas"
              className="hidden sm:inline text-lg text-gray-600 hover:text-slate-900"
            >
              Áreas
            </a>

            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center rounded-lg border border-emerald-600 px-6 py-2.5 text-lg font-medium text-emerald-700 hover:bg-emerald-50 transition"
            >
              WhatsApp
            </a>
          </div>

        </div>
      </div>
    </header>
  );
};

export default NavMenu;
